import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  private errorMessage: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.has('message')) {
      this.errorMessage = this.route.snapshot.queryParamMap.get('message');
    } else {
      this.errorMessage = 'An error has occurred. Please try again later.';
    }
  }

}
